export class WeatherModel {
    id: number;
    main: string;
    description: string;
    constructor() {
    }
}
